var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("orcamento-consultar-filtro", {
        attrs: {
          "versao-orcamento": _vm.versaoOrcamento,
          plano: _vm.plano,
          "color-selected": "blue",
          "color-deselected": "white",
          "data-inicio": _vm.dataInicio,
          "data-fim": _vm.dataFim,
        },
      }),
      _vm._v(" "),
      _c("div", [_c("orcamento-consultar-pivot-grid")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }